import { Session } from 'next-auth'
import { SessionProvider } from 'next-auth/react'
import type { AppProps as NextAppProps } from 'next/app'
import './shadcn_style.css'
import './global_style.css'

import { Settings } from 'luxon'
import { Toaster } from 'src/components/shadcn-ui/toaster'
import {
    HydrationBoundary,
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'

import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// TODO: this does not work if you are out of the country.
Settings.defaultZone = 'Africa/Johannesburg' // Set the timezone
Settings.defaultLocale = 'en-GB' // Set the locale
Settings.throwOnInvalid = true
declare module 'luxon' {
    interface TSSettings {
        throwOnInvalid: true
    }
}

// modified version - allows for custom pageProps type, falling back to 'any'
type AppProps<P = any> = {
    pageProps: P & { dehydratedQueryState?: SuperJSONResult }
} & Omit<NextAppProps<P>, 'pageProps'>

interface CustomPageProps {
    // <--- your custom page props
    session: Session
}

export default function App({
    Component,
    pageProps: { session, dehydratedQueryState, ...pageProps },
}: AppProps<CustomPageProps>) {
    const [queryClient] = useState(() => new QueryClient({}))
    const queryState = useMemo(() => {
        if (!dehydratedQueryState) {
            return undefined
        }
        return superjson.deserialize(dehydratedQueryState)
    }, [dehydratedQueryState])
    return (
        <QueryClientProvider client={queryClient}>
            <HydrationBoundary
                state={queryState}
                options={{
                    defaultOptions: {
                        deserializeData: superjson.deserialize,
                    },
                }}
            >
                <SessionProvider session={session}>
                    <Head>
                        <meta
                            name="viewport"
                            content="width=device-width, initial-scale=1.0"
                        />
                    </Head>
                    <Component {...pageProps} />
                    <Toaster />
                    <ReactQueryDevtools />
                </SessionProvider>
            </HydrationBoundary>
        </QueryClientProvider>
    )
}

import superjson, { SuperJSONResult } from 'superjson'
import Head from 'next/head'
import { useMemo, useState } from 'react'

// we do this for side effects.
import 'src/lib/superjson'
